var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-wrap"},[_c('Form',{attrs:{"formData":_vm.formData,"topic_id":_vm.$route.params.id,"isEdit":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }